import { version } from '../../package.json';

const config = (() => {
    return {

        /**
         * Gets the current application version.
         *
         * @returns string
         */
        getAppVersion: function () {
            return version;
        },

        /**
         * Gets the current application url.
         *
         * @returns string
         */
        getApiBaseUrl: function () {
            return process.env.REACT_APP_API_BASE_URL;
        },

        /**
         * Gets the current booking url.
         *
         * @returns string
         */
        getBookingToolUrl: function () {
            return process.env.REACT_APP_BOOKING_TOOL_URL;
        },

        /**
         * Gets the MOBIAN Thank you Page if a payment has been succeeded/failed.
         *
         * @returns string
         */
        getMobianPaymentRedirectPage: function () {
            return process.env.REACT_APP_MOBIAN_PAYMENT_PAGE;
        },

        /**
         * Gets the google analytics tracking id environment variable.
         *
         * @returns string
         */
        getGoogleAnaltyicsTrackingId: function () {
            return process.env.REACT_APP_GOOGLE_ANALYTICS;
        },

        /**
         * Returns the start date for the company online bookings system.
         *
         * @returns Date
         */
        getMobianBigBang: function () {
            return new Date('2014-06-01T00:00:00Z');
        },

        /**
         * Gets the MapboxGL access token
         *
         * @returns string
         */
        getMapBoxAccessToken: function () {
            return process.env.REACT_APP_MIX_MAPBOX_KEY;
        },
    };
})();

export default config;



// WEBPACK FOOTER //
// ./src/helpers/config.js